import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
//import { admin_cooler_dropdown_data } from 'src/helper/static';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable, SubscriptionLike } from 'rxjs';
import { adminSku, adminCoolerDropDown } from '../../modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { environment } from 'src/environments/environment';
import { Papa } from 'ngx-papaparse';

@Component({
  selector: 'app-admin-product-panel',
  templateUrl: './admin-product-panel.component.html',
  styleUrl: './admin-product-panel.component.css',
})
export class AdminProductPanelComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('productfileInput') fileInputRef!: ElementRef;
  columns = [
    'sku_name',
    'sku_image_uri',
    'height_mm',
    'diameter_mm',
    'pack_type_revised',
  ];
  pageSize: number = 4;
  pageIndex: number = 0;
  start: number = 0;
  end: number = 4;
  productNames: string[] = [];
  packs: string[] = [];
  selectionSequence = ['product_name', 'pack'];
  loader: Observable<boolean> = this.planogramState.loader;
  is_show_loader = false;
  admin_sku_data_subscription: SubscriptionLike;
  admin_sku_data_observable: Observable<adminSku[]> =
    this.planogramState.admin_sku_data;
  admin_sku_data: adminSku[];
  dataSource = new MatTableDataSource();
  admin_product_dropdown_form_group: FormGroup;
  filtered_admin_sku_data:adminSku[];

  constructor(
    private _formBuilder: FormBuilder,
    private planogramState: PlanogramStateService,
    private papa: Papa
  ) {
    this.admin_product_dropdown_form_group = this._formBuilder.group({
      product_name: new FormControl({ value:[], disabled: false }),
      pack: new FormControl({ value: [], disabled: false }),
    });
    this.planogramState.getAdminSkuData();
  }

  ngOnInit(): void {
    this.admin_sku_data_subscription = this.admin_sku_data_observable.subscribe(
      (data) => {
        if (data && data.length > 0) {
          this.admin_sku_data = data;
          this.filtered_admin_sku_data=data
          this.getUniqueColumnValues(data, 0);
          this.dataSource.data = data.slice(0, 4);
        }
      }
    );

  }

  toggleSelection(name:string ,formName:string,index:number){
    let sequence=[this.productNames,this.packs];
    if(name=="All" && !this.admin_product_dropdown_form_group.controls[formName]?.value.includes("All")){
      this.admin_product_dropdown_form_group.controls[formName]?.setValue([]);
    }
    else if (
      name=="All" && this.admin_product_dropdown_form_group.controls[formName].value.includes('All')
    ) {
      this.selectionSequence.forEach((v, i) => {
        if (i >= index && i < this.selectionSequence.length) {
              this.admin_product_dropdown_form_group.controls[v]?.setValue(sequence[i]);
        }
      });
    }
    else {
      
      if(!this.admin_product_dropdown_form_group.controls[formName].value.includes(name) && this.admin_product_dropdown_form_group.controls[formName].value.includes("All")){
        this.admin_product_dropdown_form_group.controls[formName]?.setValue(sequence[index].filter((v:any)=>v!=="All" && v!==name));
      }
      this.selectionSequence.forEach((v, i) => {
       if (i > index && i < this.selectionSequence.length) {
        this.admin_product_dropdown_form_group.controls[v]?.setValue(sequence[i]);
       }
     });
   }
   this.onfilterChange(index,formName)
  }

  setInitialSelection(index:number) {
    let sequence=[this.productNames,this.packs];
    this.selectionSequence.forEach((dropdown,i)=>{
      if(index==0 || (i>=index && i<this.selectionSequence.length))
        this.admin_product_dropdown_form_group.controls[dropdown]?.setValue(
        sequence[i]
      );
    })
  }

  getUniqueColumnValues(data: any, index: number) {
    let product_names: { [key: string]: number } = {};
    let packs: { [key: string]: number } = {};
    data.forEach((v: any) => {
      if (!product_names[v.sku_name] && v.sku_name.length!=0) {
        product_names[v.sku_name] = 1;
      }
      if (!packs[v.pack_type_revised] && v.pack_type_revised.length!=0) {
        packs[v.pack_type_revised] = 1;
      }
    });
    if (index == 0) this.productNames = ['All', ...Object.keys(product_names)];
    if (index <= 1) this.packs = ['All', ...Object.keys(packs)];
    this.setInitialSelection(index);
  }

  paginationChange(pageEvt: PageEvent) {
    this.start = pageEvt.pageIndex * this.pageSize;
    this.end = this.start + this.pageSize;
    this.pageIndex = pageEvt.pageIndex;
    this.dataSource.data = this.admin_sku_data.slice(this.start, this.end);
  }

  openInputForUpload(): void {
    this.fileInputRef.nativeElement.click();
  }

  uploadCsv(event: any) {
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    this.planogramState.uploadAdminSku(formData);
  }

  downloadSkuData(filename = 'data') {
    let headers = Object.keys(this.admin_sku_data[0]);
    let data:any = this.admin_sku_data;
    headers=headers.filter(v=>v!="id" && v!="status" && v!=="sku_name")
   // let csvData = this.ConvertToCSV(data, headers);
    let config={columns:headers}
    let result = this.papa.unparse(data,config);
    let blob = new Blob(['\ufeff' + result], {
      type: 'text/csv;charset=utf-8;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  onfilterChange(index: number, formName: string) {
    let selectedProductName =
      this.admin_product_dropdown_form_group.controls['product_name'].value;
    let selectedPack =
      this.admin_product_dropdown_form_group.controls['pack'].value;
    if (formName == 'product_name' && selectedProductName.includes('All')) {
      this.filtered_admin_sku_data = this.admin_sku_data;
      this.dataSource.data = this.filtered_admin_sku_data.slice(0, 4);
      this.getUniqueColumnValues(this.filtered_admin_sku_data, 0);
    } else {
      this.filtered_admin_sku_data = this.admin_sku_data.filter(
        (v) =>
          (!selectedProductName.includes('All') && selectedProductName.length !== 0
            ? selectedProductName.includes(v['sku_name'])
            : true) &&
          (!selectedPack.includes('All') && selectedPack.length !== 0
            ? selectedPack.includes(v['pack_type_revised'])
            : true) 
      );
      this.dataSource.data = this.filtered_admin_sku_data.slice(0, 4);
      this.getUniqueColumnValues(this.filtered_admin_sku_data, index + 1);
    }
    this.pageIndex = 0;
    this.start = 0;
    this.end = 4;
  }
}
